import React from "react";
import "./App.css";
import Rotas from "./rotas";

function App() {
  return <Rotas />;
}

export default App;